import React from "react";
import BlogCard from "./BlogCard";

const RecentBlogArea = ({items}) => {

    return (
        <div className="blog-area py-4 mt-5">
            <div className="container mx-auto">
                <div className="section-title">
                    <h2>Dernières nouvelles</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {items.map((blog) => (
                        <BlogCard key={blog.id} blog={blog} index={blog.id}/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RecentBlogArea;
